export const STRING = 'string'
